import React from 'react';
import ReactDOMServer from "react-dom/server";
import styled, { css, keyframes } from "styled-components";
import { locHtml } from "../locHtml";

const ProgressBox = styled("div")`
    margin-top: 20px;
    border-radius: 10px;
    padding: 20px;
    background-color: white;
    display: flex;
    flex-direction: column;
    color: grey;
`;

const GraphBox = styled("div")`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 240px;
    margin: auto;
    height: 148px;
`;

const growUpSolo = keyframes`
    from {
        height: 0;
    }
    to {
        height: 66px;
    }
`;

const growUpWith = keyframes`
    from {
        height: 0;
    }
    to {
        height: 92px;
    }
`;

const textAppearAnimation = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 100%;
    }
`;

const animationSolo = css`
    height: 0;
    animation: ${growUpSolo} 1.2s ease-out 0.3s forwards;
`;

const animationWith = css`
    height: 0;
    animation: ${growUpWith} 1.2s ease-out 0.3s forwards;
`;

const withTextAnimation = css`
    opacity: 0;
    animation: ${textAppearAnimation} 1.2s step-end 0.3s forwards;
`;

export const SoloGraph = styled.div`
    ${animationSolo};
    animation-delay: 0.7s;
`;

export const WithGraph = styled.div`
    ${animationWith};
    animation-delay: 0.7s;
`;

export const WithText = styled.div`
    ${withTextAnimation};
    animation-delay: 0.3s;
`


const fasterProgressTogether = (t: (key: string) => string) => <div className="new-quote-container centered">
  <div className="splash-header">
  <ProgressBox>
      <GraphBox>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: "center", flex: 1, marginRight: "10px"}}>
          <div style={{
            display: 'flex',
            flexDirection: "column",
            justifyContent: "end",
            borderRadius: '10px 10px 0 0',
            backgroundColor: "#f5f5f5",
            width: "88px",
            height: "120px"
          }}>
            <SoloGraph style={{backgroundColor: '#333333', borderRadius: '10px 10px 0 0'}}></SoloGraph>
          </div>
          <div style={{textAlign: 'center', marginTop: "12px"}}>{t("splash.gymBuddy.fasterProgressTogether.solo")}</div>
        </div>

        <div style={{display: 'flex', flexDirection: 'column', alignItems: "center", flex: 1, marginRight: "10px"}}>
          <div style={{
            display: 'flex',
            flexDirection: "column",
            justifyContent: "end",
            borderRadius: '10px 10px 0 0',
            backgroundColor: "#f5f5f5",
            width: "88px",
            height: "120px"
          }}>
            <WithGraph style={{
              padding: "12px",
              backgroundColor: '#dfb140',
              borderRadius: '10px 10px 0 0'
            }}>
              <WithText style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center"
              }}>
                <div style={{color: "black", fontWeight: "900", fontSize: "28px"}}>1.5X</div>
                <div style={{color: "black", fontWeight: "900", fontSize: "14px"}}>{t("splash.gymBuddy.fasterProgressTogether.faster")}</div>
              </WithText>
            </WithGraph>
          </div>
          <div style={{textAlign: 'center', marginTop: "12px"}}>{t("splash.gymBuddy.fasterProgressTogether.withPartners")}</div>
        </div>
      </GraphBox>
    </ProgressBox>
    <h1 className="no-word-break">{t("splash.gymBuddy.fasterProgressTogether.title")}</h1>
    <div className="quote">
      {t("splash.gymBuddy.fasterProgressTogether.text")}
    </div>
  </div>
</div>;

const fasterProgressTogetherElement = {
  name: 'faster-progress-together',
  type: 'html',
  html: locHtml((t) => ReactDOMServer.renderToStaticMarkup(fasterProgressTogether(t))),
}

export default fasterProgressTogetherElement;
